export default function Watermark() {
  const email = localStorage.getItem("email");

  return (
    <div style={{
      position: "fixed",
      bottom: 10,
      right: 10,
      opacity: 0.2
    }}>
      {email}
    </div>
  );
}